import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

// @ts-ignore
import { Close, MinusSquare, PlusSquare, Pulldown } from '../../../icons';

// @ts-ignore
import styles from './PdfModal.scss';

type PdfModalProps = {
  isOpen: boolean;
  children: ReactNode;
};

export const PdfModal: FC<PdfModalProps> = ({ isOpen, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>{children}</div>
    </div>
  );
};

type HeaderProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Header: FC<HeaderProps> = ({ children, className, ...props }) => {
  return (
    <div className={classnames(styles.header, className)} {...props}>
      {children}
    </div>
  );
};

type TitleProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Title: FC<TitleProps> = ({ children, className, ...props }) => {
  return (
    <div className={classnames(styles.title, className)} {...props}>
      {children}
    </div>
  );
};

type ToolContainerProps = JSX.IntrinsicElements['div'] & {
  onClose: () => void;
  children: ReactNode;
};

export const ToolContainer: FC<ToolContainerProps> = ({ onClose, children, className, ...props }) => {
  return (
    <div className={classnames(styles.toolContainer, className)} {...props}>
      <div className={styles.tools}>{children}</div>
      <Close className={styles.icon} onClick={onClose} />
    </div>
  );
};
